import React, { useEffect } from "react";
import AOS from 'aos';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

export const Hotgame = (props) => {
  useEffect(() => {
    AOS.init({
      offset: 200,         // 觸發動畫的偏移量 (px)
      delay: 100,          // 延遲 (ms)
      duration: 400,       // 動畫持續時間 (ms)
      easing: 'ease',      // 動畫曲線
      once: false,         // 是否只動畫一次
      mirror: false,       // 滾動時是否鏡像動畫
      anchorPlacement: 'top-bottom', // 錨點位置
    });
  }, []);
  return (
    <div id="Hotgame" className="text-center">
      <div className="container">
        <div className="col-md-12 section-title">
          <img src="img/title-hotgame.png" className="img-title" alt="" />{" "}
          <h3>
            各種類型遊戲 應有盡有<br></br>
            感受簡單好上手、最豐富的娛樂體驗</h3>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-2 col-sm-2 col-xs-4 Hotgame">
                <div className="thumbnail">
                  {" "}
                  <img src={d.img} alt="..." className="Hotgame-img" data-aos="flip-down" />
                </div>
              </div>
            ))
            : "loading"}
        </div>
        
      </div>
    </div >
  );
};
